import { Tooltip, Typography } from "antd";
import clsx from "clsx";
import { motion } from "framer-motion";
import { useNavigate, routes } from "@shared/lib/react-router";

import "./navigation-project.scss";

export const NavigationProject = ({
  collapsed,
  projectId,
  projectName,
  projectAddress,
}: {
  collapsed: boolean;
  projectId: string;
  projectName: string;
  projectAddress: string;
}) => {
  const navigate = useNavigate();
  const projectLink = routes.general.root(projectId);

  const handleProjectClick = () => {
    navigate(projectLink);
  };

  const ProjectIcon = (
    <motion.svg
      initial={{ x: 12, opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75 3C8.50736 3 7.5 3.00736 7.5 4.25V6.00002H16.5V4.25C16.5 3.00736 15.4926 3 14.25 3H9.75ZM6 4.25C6 2.17894 7.67894 1.5 9.75 1.5H14.25C16.3211 1.5 18 2.17894 18 4.25V6.75002C18 7.16423 17.6642 7.50002 17.25 7.50002H6.75C6.33579 7.50002 6 7.16423 6 6.75002V4.25Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.78844 12.1589C1.97048 12.0167 2.20785 11.9664 2.4319 12.0224L12 15L21.5681 12.0224C21.7922 11.9664 22.0295 12.0167 22.2116 12.1589C22.3936 12.301 22.5 12.5191 22.5 12.75V19.25C22.5 20.2165 21.7165 21 20.75 21H3.25C2.28351 21 1.5 20.2165 1.5 19.25V12.75C1.5 12.5191 1.6064 12.301 1.78844 12.1589ZM3 13.7106V19.25C3 19.3881 3.11192 19.5 3.25 19.5H20.75C20.8881 19.5 21 19.3881 21 19.25V13.7106L12.4746 16.4552C12.1959 16.5249 11.7937 16.5249 11.5151 16.4552L3 13.7106Z"
        fill="#333333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 7.75C1.5 6.78348 2.28351 6 3.25 6H20.75C21.7165 6 22.5 6.78349 22.5 7.75V12.25C22.5 12.6642 22.1642 13 21.75 13C21.3358 13 21 12.6642 21 12.25V7.75C21 7.61191 20.8881 7.5 20.75 7.5H3.25C3.11192 7.5 3 7.61192 3 7.75V12.25C3 12.6642 2.66421 13 2.25 13C1.83579 13 1.5 12.6642 1.5 12.25V7.75Z"
        fill="#333333"
      />
      <path
        d="M13.25 11.5C13.25 12.1904 12.6904 12.75 12 12.75C11.3097 12.75 10.75 12.1904 10.75 11.5C10.75 10.8097 11.3097 10.25 12 10.25C12.6904 10.25 13.25 10.8097 13.25 11.5Z"
        fill="#333333"
      />
    </motion.svg>
  );

  if (collapsed)
    return (
      <div className="left-sider-project-menu left-sider-project-menu-collapsed navigation-project-collapsed-menu">
        <Tooltip placement="right" title="Главная проекта">
          <div className="menu-item-link" onClick={handleProjectClick}>
            {ProjectIcon}
          </div>
        </Tooltip>
      </div>
    );

  return (
    <div className="navigation-project-block">
      <motion.div
        initial={{ opacity: 1, x: collapsed ? -18 : 18 }}
        animate={{ opacity: collapsed ? 0 : 1, x: collapsed ? 16 : 0 }}
        transition={{ duration: 0.5 }}
      >
        <p className="navigation-project-label">ПРОЕКТ</p>
        <span>
          <span className="navigation-project-title" onClick={handleProjectClick}>
            {projectName}
          </span>
          <Typography.Text ellipsis className="navigation-project-address">
            {projectAddress}
          </Typography.Text>
        </span>
      </motion.div>

      <motion.div
        className={clsx("navigation-project-collapsed-icon", collapsed && "left-sider-project-menu-collapsed")}
        initial={{ opacity: 0 }}
        animate={{ opacity: collapsed ? 1 : 0 }}
        transition={{ duration: 0.5 }}
      >
        <Tooltip placement="right" title="Главная проекта">
          <div className="menu-item-link" onClick={handleProjectClick}>
            {ProjectIcon}
          </div>
        </Tooltip>
      </motion.div>
    </div>
  );
};
